import { combineReducers } from '@reduxjs/toolkit';

import {
  answersApi,
  configApi,
  employeesApi,
  filesApi,
  permissionsApi,
  projectsApi,
  questionsApi,
  rolesApi,
  settingsApi,
  testsApi,
  themesApi,
  usersApi,
} from '@/services';
import { resultsApi } from '@/services/api/results';
import {
  answersReducer,
  backgroundsReducer,
  configReducer,
  employeesReducer,
  filterReducer,
  permissionsReducer,
  projectsReducer,
  questionsReducer,
  resultsReducer,
  rolesReducer,
  testsReducer,
  themesReducer,
  userReducer,
} from '@/slices';
import { settingsReducer } from '@/slices/settings';

export default combineReducers({
  answers: answersReducer,
  backgrounds: backgroundsReducer,
  [answersApi.reducerPath]: answersApi.reducer,
  config: configReducer,
  [configApi.reducerPath]: configApi.reducer,
  employees: employeesReducer,
  filter: filterReducer,
  permissions: permissionsReducer,
  projects: projectsReducer,
  [testsApi.reducerPath]: testsApi.reducer,
  questions: questionsReducer,
  results: resultsReducer,
  roles: rolesReducer,
  settings: settingsReducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [themesApi.reducerPath]: themesApi.reducer,
  tests: testsReducer,
  [questionsApi.reducerPath]: questionsApi.reducer,
  [projectsApi.reducerPath]: projectsApi.reducer,
  [employeesApi.reducerPath]: employeesApi.reducer,
  themes: themesReducer,
  [resultsApi.reducerPath]: resultsApi.reducer,
  [rolesApi.reducerPath]: rolesApi.reducer,
  [permissionsApi.reducerPath]: permissionsApi.reducer,
  user: userReducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [filesApi.reducerPath]: filesApi.reducer,
});
